import React from "react";
import { Banner } from "../components";
import "./index.css";

const Home = () => {
  return (
    <>
      <Banner />
    </>
  );
};

export { Home };
